
export class WinnerVO {
    public index: number = 0;
    public c1: string;
    public c2: string;
    public chips: number = NaN;
    public handcategory: number = 0;
}
